import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useAddressLabel } from '../../../hooks/use-address-label';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
import { useCountryCode } from '../../multiline-address/multiline-address/country-code-context';
export const MlaCityWUT = props => {
  const fieldType = FIELD_TYPES.MLA_CITY;
  const label = useAddressLabel('city');
  const countryCode = useCountryCode();
  return /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, props, {
    fieldType: fieldType,
    label: label,
    countryCode: countryCode
  }));
};
//# sourceMappingURL=mla-city-wut.js.map